import { useMemo } from 'react';

import { MarginPosition, MarginPositionsQuery, MarginPositionStatus } from '@swyftx/margin/build/types';

import { useFetchMarginPositions } from './useFetchMarginPositions';

type Props = {
  pageSize?: number;
  status?: MarginPositionStatus[];
  sortBy?: MarginPositionsQuery['sortBy'];
  sortDir?: MarginPositionsQuery['sortDir'];
};

const useMarginPositions = (
  { pageSize, status = [], sortBy, sortDir }: Props = {
    pageSize: 250,
    status: [],
    sortBy: 'lastUserAction',
    sortDir: 'desc',
  },
) => {
  const { data, fetchNextPage, fetchPreviousPage, isFetchingNextPage, hasNextPage, isFetching, isLoading, isError } =
    useFetchMarginPositions({
      pageSize,
      status,
      sortBy,
      sortDir,
    });

  const positions = useMemo(
    (): MarginPosition[] | undefined => data?.pages?.flatMap((p) => p.positions),
    [data?.pages],
  );

  return {
    positions,
    isLoading,
    isError,
    isFetchingNextPage,
    hasNextPage,
    isFetching,
    fetchNextPage,
    fetchPreviousPage,
  };
};

export { useMarginPositions };
